module.exports = __webpack_public_path__ + "img/ico-01.a17f21c0.png";